import {get, post, postJson} from './axios'

// 获取时间段内的催付信息

const RESOURCE_BASE_PATH = '/notpayremind'

export const getRemindByTime = p => postJson(`${RESOURCE_BASE_PATH}/getRemindByTime`, p);


///最近一次精准营销效果分析数据
export const homeMarketing = p => get(`/home/precision-marketing/last`, p);
